import React from 'react';

import { useHumanTaskEventsRefresh, useMyTasks } from '../api/queries/use-my-tasks';
import { NavCount } from '../styles';

const pendingLabel = (count) => (count === 1 ? '1 tarea pendiente' : `${count} tareas pendientes`);

/**
 * Pending-task counter on the "Inicio" entry of the main nav. Nav only mounts
 * it for users who receive tasks. It is on every screen of the dashboard, so
 * it also keeps the `/human-tasks/me` heartbeat (presence) and the Pusher
 * refresh alive outside Inicio. Shows nothing with zero tasks or on error.
 */
const InicioNavBadge = () => {
  useHumanTaskEventsRefresh();
  const { data } = useMyTasks();
  const count = data ? data.pendingCount : 0;
  if (!count) return null;
  return (
    <NavCount role="status" aria-label={pendingLabel(count)}>
      {count > 9 ? '9+' : count}
    </NavCount>
  );
};

export default InicioNavBadge;
